/** Dashboard widget: Learning Database rollup — reports, recommendations, tracked outcomes. */

import React, { useEffect, useState } from "react";
import { apiClient } from "@/api/client";
import type { LearningSummary } from "@/types";
import WidgetCard from "./WidgetCard";

export default function LearningProgressWidget(): React.ReactElement {
  const [summary, setSummary] = useState<LearningSummary | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .get<LearningSummary>("/learning/summary")
      .then(({ data }) => setSummary(data))
      .catch(() => setError("Unable to load learning summary"));
  }, []);

  return (
    <WidgetCard title="Learning progress" isLoading={summary === null && !error} error={error}>
      {summary && (
        <>
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div>
              <p className="font-mono text-lg text-mist-100">{summary.research_reports_generated}</p>
              <p className="text-xs text-mist-400">Reports</p>
            </div>
            <div>
              <p className="font-mono text-lg text-mist-100">{summary.allocation_recommendations_generated}</p>
              <p className="text-xs text-mist-400">Allocations</p>
            </div>
            <div>
              <p className="font-mono text-lg text-mist-100">{summary.outcomes_evaluated}</p>
              <p className="text-xs text-mist-400">Outcomes evaluated</p>
            </div>
            <div>
              <p className="font-mono text-lg text-mist-100">{summary.outcomes_pending}</p>
              <p className="text-xs text-mist-400">Pending</p>
            </div>
          </div>
          {summary.latest_evaluation && summary.latest_evaluation.hit_rate_pct !== null && (
            <p className="text-xs text-mist-400">
              Latest hit rate: {Number(summary.latest_evaluation.hit_rate_pct).toFixed(1)}%
            </p>
          )}
        </>
      )}
    </WidgetCard>
  );
}
